const Land = {
    land: {
        land: 'Finca',
        lands: 'Fincas',
        add: 'Añadir finca',
        seeAnimals: 'Ver animales',
        first: 'Bienvenido!!! No has creado ninguna finca aún, por favor crea tu primera finca para empezar.',
        noAnimals: 'No hay animales aún en esta finca.',
        noDescription: 'Sin descripción',
        createMap: 'Crear un mapa',
        size: 'Hectáreas',
        location: 'Ubicación',
        map: 'Mapa',
        owner: 'Propietario',
        reader: 'Invitado',
        editor: 'Colaborador',
        count: 'Recontar',
        loadingMap: 'Cargando mapa...',
        sharedWith: 'Compartido con',
    }
};

export default Land;
